var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3812 7.81298L15.5467 5.64746C15.9935 5.20024 16.5241 4.84543 17.108 4.6033C17.692 4.36117 18.318 4.23648 18.9501 4.23633C19.5823 4.23618 20.2083 4.36059 20.7924 4.60244C21.3765 4.8443 21.9072 5.19886 22.3542 5.64588C22.8012 6.09289 23.1558 6.6236 23.3976 7.20768C23.6395 7.79176 23.7639 8.41777 23.7638 9.04995C23.7636 9.68212 23.6389 10.3081 23.3968 10.892C23.1547 11.476 22.7998 12.0066 22.3526 12.4534L19.259 15.547C18.8121 15.9938 18.2816 16.3483 17.6977 16.5902C17.1139 16.832 16.4881 16.9565 15.8561 16.9565C15.2241 16.9565 14.5983 16.832 14.0144 16.5902C13.4305 16.3483 12.9 15.9938 12.4531 15.547",
    stroke: "#2A272E",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6189 20.187L12.4534 22.3525C12.0066 22.7997 11.476 23.1545 10.892 23.3967C10.3081 23.6388 9.68212 23.7635 9.04995 23.7636C8.41777 23.7638 7.79176 23.6394 7.20768 23.3975C6.6236 23.1557 6.09289 22.8011 5.64588 22.3541C5.19886 21.9071 4.8443 21.3764 4.60244 20.7923C4.36059 20.2082 4.23618 19.5822 4.23633 18.95C4.23648 18.3178 4.36117 17.6919 4.6033 17.1079C4.84543 16.5239 5.20024 15.9934 5.64746 15.5466L8.74105 12.453C9.18794 12.0061 9.71846 11.6516 10.3023 11.4098C10.8862 11.1679 11.512 11.0435 12.144 11.0435C12.776 11.0435 13.4018 11.1679 13.9857 11.4098C14.5695 11.6516 15.1001 12.0061 15.547 12.453",
    stroke: "#2A272E",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.76feac6feb27df0a5b06b6c0fcf8a5c0.svg";
export { ForwardRef as ReactComponent };